import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Swiper, SwiperSlide } from 'swiper/react'
import SimpleVideo from '../../video/simple-video'

export default props => {
    useStyles(classes)
    const { videos, clickHandle } = props

    const [activeVideoIndex, setActiveVideoIndex] = React.useState(0)
    const [swiper, setSwiper] = React.useState(null)

    const endedHandle = () => {
        if (swiper) {
            if(activeVideoIndex + 1 <= videos.length - 1){
                swiper.slideNext()
            }else{
                swiper.slideTo(0, 0)
            }
            
        }else{
            console.log('ended')
        }
    }

    const slideChangeHandle = (sw) => {
        setActiveVideoIndex(sw.activeIndex)
        console.log(sw.activeIndex)
    }

    return <Swiper className={classes.SwiperVideo} onSwiper={setSwiper} slidesPerView={1} onSlideChange={slideChangeHandle}>
        {
            videos.map((video, index) => {
                return <SwiperSlide key={index} className={classes.SwiperVideoSlide}>
                    <SimpleVideo clickHandle={() => clickHandle(index, video)} video={video} endedHandle={endedHandle} shouldPlay={activeVideoIndex === index} />
                </SwiperSlide>
            })
        }
    </Swiper>
}